export default "__VITE_ASSET__CPE4G4zA__"